import { del, EndPoints, get, patch, post } from '../';
export function list() {
    return get(EndPoints.models, { all: 1 });
}
export function createModel(request) {
    return post(EndPoints.modelsCreate, request);
}
export function updateModel(request) {
    return patch(EndPoints.modelsUpdate, request);
}
export function deleteModel(request) {
    return del(EndPoints.modelsDelete, request);
}
